import {defineMessages} from 'react-intl'

export const badgeMessages = defineMessages({
  upgradeAndSave: {
    id: 'anchorSimilarHotels.upgradeAndSave',
    defaultMessage: 'Upgrade and save'
  },
  biggestSaving: {
    id: 'anchorSimilarHotels.biggestSaving',
    defaultMessage: 'Biggest saving'
  },
  bestRatedNearby: {
    id: 'anchorSimilarHotels.bestRatedNearby',
    defaultMessage: 'Best rated nearby'
  }
})

export const distanceMessages = defineMessages({
  miles: {
    id: 'anchorSimilarHotels.milesAway',
    defaultMessage: '{distance, plural, one {# mile away} other {# miles away}}'
  },
  kilometers: {
    id: 'anchorSimilarHotels.kilometersAway',
    defaultMessage: '{distance, plural, one {# km away} other {# km away}}'
  }
})

export const perkMessages = defineMessages({
  cheaper: {id: 'percentCheaper', defaultMessage: '{percent}% cheaper'},
  similarPrice: {
    id: 'anchorSimilarHotels.similarPrice',
    defaultMessage: 'Similar price'
  },
  freeCancellation: {
    id: 'cancellationPenalties.freeCancellation',
    defaultMessage: 'Free cancellation'
  },
  breakfast: {
    id: 'mealType.breakfastIncluded',
    defaultMessage: 'Breakfast included'
  },
  betterRating: {
    id: 'anchorSimilarHotels.betterRating',
    defaultMessage: 'Better guest rating'
  },
  similarRating: {
    id: 'anchorSimilarHotels.similarRating',
    defaultMessage: 'Same guest rating'
  },
  stepUp: {
    id: 'anchorSimilarHotels.stepUp',
    defaultMessage: 'Higher star class'
  },
  sameStars: {
    id: 'anchorSimilarHotels.sameStars',
    defaultMessage: 'Same star class'
  },
  moreReviewed: {
    id: 'anchorSimilarHotels.moreReviewed',
    defaultMessage: 'More reviewed'
  }
})

export const MIN_UPGRADE_RATING_GAIN = 0.5
export const MIN_UPGRADE_SAVING = 0.1
export const MIN_BIGGEST_SAVING = 0.15
export const MAX_RATING_DROP = 1
export const MIN_REVIEWS_FOR_BEST_RATED = 500

// Avoid losing threshold matches to floating-point rounding.
export const comparisonTolerance = 1e-9
export const SIMILAR_PRICE_RANGE = 0.005
export const MIN_CHEAPER_SAVING = 0.05
export const SIMILAR_RATING_RANGE = 0.1
export const MAX_PERKS = 2
export const SIMILAR_HOTELS_LIMIT = 10

// Provisional heuristics; see the similar-properties-srp/ranking spec.
export const PREFERRED_RADIUS_KM = 3
export const DISTANCE_PENALTY_PER_KM = 0.25
export const EXTRA_DISTANCE_PENALTY_PER_KM = 0.25
export const UNKNOWN_DISTANCE_PENALTY = 1
export const UNKNOWN_PROPERTY_TYPE_PENALTY = 0.15
export const DIFFERENT_PROPERTY_TYPE_PENALTY = 0.2
export const MINIMUM_REVIEW_COUNT = 20
export const MAXIMUM_REVIEW_COUNT = 300
export const ANCHOR_REVIEW_COUNT_RATIO = 0.1
export const LOW_REVIEW_CONFIDENCE_PENALTY = 0.3
export const MISSING_QUALITY_FIELD_PENALTY = 0.3
export const STAR_DIFFERENCE_ALLOWANCE = 1
export const STAR_DIFFERENCE_PENALTY = 0.3
export const RATING_DROP_ALLOWANCE = 1
export const RATING_DROP_PENALTY = 0.27
export const QUALITY_PER_RATING_POINT = 0.27
export const QUALITY_PER_STAR = 0.23
export const MINIMUM_PRICE_RATIO = 0.7
export const MAXIMUM_PRICE_RATIO = 1.2
export const PRICE_TIER_PENALTY_WEIGHT = 2
export const FAIR_PREMIUM_BASE = 0.025
export const MAXIMUM_VALUE_CONTRIBUTION = 0.5
export const QUALITY_SCORE_WEIGHT = 0.5
export const SIMILAR_HOTELS_TIMEOUT_MS = 15_000
export const MIN_SIMILAR_HOTELS = 3
export const CARD_WIDTH = 240

export const sectionMessages = defineMessages({
  nearbyTitle: {
    id: 'anchorSimilarHotels.nearbyTitle',
    defaultMessage: 'Similar stays nearby'
  },
  availableTitle: {
    id: 'anchorSimilarHotels.availableTitle',
    defaultMessage: 'Available for your dates'
  },
  comparedWith: {
    id: 'anchorSimilarHotels.comparedWith',
    defaultMessage: 'Compared with {hotelName}'
  },
  previousHotels: {
    id: 'anchorSimilarHotels.previousHotels',
    defaultMessage: 'Previous hotels'
  },
  nextHotels: {
    id: 'anchorSimilarHotels.nextHotels',
    defaultMessage: 'Next hotels'
  }
})
